import React, { Component, Fragment } from "react"
import { Scrollbars } from "react-custom-scrollbars"
import { connect } from "react-redux"
import cx from "classnames"
import Select from "react-select"

class RegionMobile extends Component {
  state = {
    cityValue: null
  }
  render() {
    return (
      <Fragment>
        {this.props.regions.data && (
          <div className="locationMobileBody">
            <div className="locationMobileSelectWrapper">
              <select
                className="locationMobileSelect"
                value={this.props.regions.currentRegion}
                onChange={event => {
                  this.props.getRegion(event.target.value)
                }}>
                {transformToSelect(this.props.regions.data).map((option, index) => {
                  return (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  )
                })}
              </select>
            </div>
            <div className="locationMobileSelectWrapper">
              <select
                className="locationMobileSelect"
                value={this.props.regions.currentCity}
                onChange={event => {
                  this.props.setCity({
                    id: event.target.value,
                    label: event.target.options[event.target.selectedIndex].text
                  })
                }}>
                {this.props.regions.currentRegion &&
                  transformToCitySelect(this.props.regions.regions[this.props.regions.currentRegion].payload).map(
                    (option, index) => {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      )
                    }
                  )}{" "}
              </select>
            </div>
          </div>
        )}
      </Fragment>
    )
  }
}

const mapState = state => ({
  regions: state.regions
})

const mapDispatch = ({ regions: { getRegions, getRegion, setCity, open } }) => ({
  getRegions: () => getRegions(),
  getRegion: region => getRegion(region),
  setCity: city => setCity(city),
  setOpen: () => open()
})
export default connect(
  mapState,
  mapDispatch
)(RegionMobile)

const transformToSelect = arr => {
  return flatten(
    arr.map(item => {
      return item.values.map(value => {
        return {
          value: value.id,
          label: value.region
        }
      })
    })
  )
}

const transformToCitySelect = arr => {
  return flatten(
    arr.map(item => {
      return item.values.map(value => {
        return {
          value: value.id,
          label: value.city
        }
      })
    })
  )
}

function flatten(arr) {
  return arr.reduce(function(flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten)
  }, [])
}
